export const environment = {
    production: true,
    network: 'testnet' as 'mainnet' | 'testnet',

    publicRPCEndpoint: 'https://carrot.megaeth.com/rpc',
    
    rpcEndpoint: 'https://api.moncha.in/rpc/testnet',
    wsEndpoint: 'wss://api.moncha.in/ws/testnet',
    faucetEndpoint: 'https://api.moncha.in/faucet',
    frensFaucetEndpoint: 'https://api.moncha.in/frens-faucet',
    // Relay has no MegaETH testnet route; empty disables the funding modal.
    relayEndpoint: '',

    explorerTxLink: 'https://testnet-mega.etherscan.io/tx/',
    explorerAddressLink: 'https://testnet-mega.etherscan.io/address/',

    chainId: 6343,
    chainName: 'MegaETH Testnet',
    multicallAddress: '0x2152EA9e94fC62d676d65CB40cB2d5b8234bb8f3' as `0x${string}`,

    twitter: {
        clientId: 'UTF2bkFqNnRNQnFFV1BBU1MyU2g6MTpjaQ',
        redirectUri: 'https://stomp.gg/auth/twitter/callback',
    },
};

